import key from "../config/config";
import * as api from "../routes/userroutefront";
import axios from "../config/axios";

export const getDailyGoldCoinStatus = async () => {
  try {
    const response = await axios({
      url: key.API_URL + api.dailyGoldCoinStatus,
      method: "get",
    });
    return {
      status: response?.data?.status === true,
      result: response?.data?.result,
      message: response?.data?.message,
      code: response?.data?.code,
    };
  } catch (err) {
    return {
      status: false,
      message: err?.response?.data?.message || "Unable to load daily reward status.",
      code: err?.response?.data?.code,
    };
  }
};

// The server derives both the player and award from the authenticated session
// and current admin settings. Deliberately send no amount, bucket, or date.
export const claimDailyGoldCoins = async () => {
  try {
    const response = await axios({
      url: key.API_URL + api.dailyGoldCoinClaim,
      method: "post",
    });
    return {
      status: response?.data?.status === true,
      result: response?.data?.result,
      message: response?.data?.message,
      code: response?.data?.code,
    };
  } catch (err) {
    return {
      status: false,
      message: err?.response?.data?.message || "Unable to claim daily Gold Coins.",
      code: err?.response?.data?.code,
      result: err?.response?.data?.result,
    };
  }
};
